import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FOUNDATION_INFO } from "@/lib/initiatives";

const FAQ = [
  {
    q: "Is my donation eligible for 80G tax benefit?",
    a: `Yes. UB Maitreya Foundation is registered under section 12AB and approved under section 80G of the Income Tax Act, 1961. Our 80G Approval No. is ${FOUNDATION_INFO.reg80g}, approved on ${FOUNDATION_INFO.reg80g_date}, valid ${FOUNDATION_INFO.ay_validity}.`,
  },
  {
    q: "How and when will I receive my receipt?",
    a: "You will receive an official donation receipt and 80G certificate details on your email address immediately after a successful payment. You can also print the receipt directly from our success page.",
  },
  {
    q: "Do I need to provide my PAN?",
    a: "PAN is optional but recommended if you want to claim the 80G deduction on your income tax return. Without a PAN, we can still issue a receipt, but your tax filing will need the PAN to claim the deduction.",
  },
  {
    q: "What payment methods are supported?",
    a: "We accept all major debit / credit cards, UPI (Google Pay, PhonePe, Paytm and more), net-banking, and wallets via Razorpay — India's most trusted payment gateway. You may also transfer directly to our bank account using the details on this page.",
  },
  {
    q: "Can I donate for a specific cause?",
    a: "Yes. On the donation form choose the cause closest to your heart — for example Natural Farming, Women's Empowerment or Mental Health — and 100% of that contribution is directed to that initiative.",
  },
  {
    q: "Can my company make a CSR contribution?",
    a: "Absolutely. UB Maitreya Foundation is a Section 8 company registered under 80G, making us an eligible CSR partner. Please visit our CSR page and submit an enquiry — our partnerships team will design a programme that suits your objectives.",
  },
  {
    q: "Are foreign donations accepted?",
    a: "At this time we are set up to receive Indian donations under 80G. FCRA-linked foreign contributions are on our roadmap — please contact us for the current status.",
  },
];

export default function DonationFAQ() {
  return (
    <section data-testid="donate-faq" className="section-py bg-white border-t border-[#0A2540]/10">
      <div className="mx-auto max-w-4xl container-x">
        <div className="text-xs uppercase tracking-[0.24em] text-[#4A5568]">FAQs</div>
        <h2 className="mt-3 font-serif-display text-3xl md:text-5xl text-[#0A2540]">
          Everything you might want to ask.
        </h2>
        <p className="mt-3 text-[#4A5568]">
          Common questions on donations, 80G tax benefits, receipts and CSR.
        </p>
        <Accordion type="single" collapsible className="mt-10">
          {FAQ.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#0A2540]/10">
              <AccordionTrigger data-testid={`faq-q-${i}`} className="font-serif-display text-left text-lg text-[#0A2540] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4A5568] leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
